import {
  studyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGet,
  StudyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGetResponse,
  HTTPValidationError,
} from '@common/config/api/client'
import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export default function useGetReadDesignDetails(studyId: string) {
  return useQuery<
    StudyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGetResponse,
    AxiosError<HTTPValidationError>
  >({
    queryKey: ['useGetReadDesigns'],
    queryFn: async () => {
      if (!studyId) {
        throw new Error('studyId is required')
      }

      const response = await studyReadDesignDetailsStudiesStudyIdStudyReadDesignDetailsGet({
        path: { study_id: studyId },
        throwOnError: true,
      })

      return response.data
    },
    enabled: !!studyId,
    retry: false,
  })
}
